import { Quote } from "lucide-react";
import Reveal from "@/components/site/Reveal";
import SectionLabel from "@/components/site/SectionLabel";
import { TESTIMONIALS } from "@/lib/site";

export default function Testimonials() {
    return (
        <section
            data-testid="testimonials-section"
            className="relative bg-[#060c1e] py-24 md:py-32"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16">
                    <div className="md:col-span-7">
                        <Reveal>
                            <SectionLabel testId="testimonials-label">
                                Transformations
                            </SectionLabel>
                            <h2 className="mt-6 font-display font-black text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
                                Men who showed up.{" "}
                                <span className="text-[#D4AF37]">Became different.</span>
                            </h2>
                            <p className="mt-6 text-white/65 text-sm uppercase tracking-[0.15em]">
                                * Placeholder testimonials — replaced with real
                                client stories as they’re collected.
                            </p>
                        </Reveal>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {TESTIMONIALS.map((t, i) => (
                        <Reveal key={i} delay={i * 0.08}>
                            <article
                                data-testid={`testimonial-card-${i + 1}`}
                                className="bg-[#020617] border border-[#142142] p-8 h-full flex flex-col hover:border-[#1E90FF]/60 transition-all duration-500"
                            >
                                <Quote className="text-[#D4AF37]" size={28} />
                                <p className="mt-6 text-white/85 leading-relaxed flex-1">
                                    {`“${t.quote}”`}
                                </p>
                                <div className="mt-8 pt-6 border-t border-[#142142] flex items-center gap-3">
                                    <img
                                        src={t.avatar}
                                        alt={t.name}
                                        className="w-11 h-11 object-cover grayscale"
                                    />
                                    <div>
                                        <p className="font-display font-bold text-white text-sm">
                                            {t.name}
                                        </p>
                                        <p className="text-xs text-white/55">
                                            {t.role}
                                        </p>
                                    </div>
                                </div>
                            </article>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
